import Utils from '../../../../../../utils/descriptor/descriptorUtils';
import ReportsRepo from '../../../../../../utils/repository/repoertsRepo';
import { useState } from 'react';
import Loader from '../../../../../../components/loader';
import { DescriptorProps } from '../../../../../../constnats/descriptor';
import { ReportUpdateManager } from '../../../../../../utils/reportUpdateManager';
import { Button, Container, Modal } from 'semantic-ui-react';
import { reportsChangesToMatrix } from '../../../../../../utils/batchUpdateUtils';
import BatchUpdateTable from '../../../../../../components/admin/batchUpdate/batchUpdateTable/batchUpdateTable';

function getReportChanges(report, descriptors, descriptorsToUpdateStrategyMap, schemaId, companyId) {

    const updateManager = new ReportUpdateManager(report, descriptors, descriptorsToUpdateStrategyMap, schemaId, companyId)
    updateManager.remediate()
    return { updatedReport: updateManager.getUpdatedReport(), changes: updateManager.getDiffs() }
}



function getChanges(descriptors, reports, descriptorsToUpdateStrategyMap, schemaId, companyId) {
    descriptors = JSON.parse(JSON.stringify(descriptors))

    const affectedDescriptorIds = new Set()
    const changedReports = []
    for (const report of reports) {
        const reportChanges = getReportChanges(report, descriptors, descriptorsToUpdateStrategyMap, schemaId, companyId)
        if (Object.keys(reportChanges.changes).length > 0) {
            changedReports.push(reportChanges)
            for (const descriptorId of Object.keys(reportChanges.changes)) {
                affectedDescriptorIds.add(descriptorId)
            }
        }
    }

    const dynamicFlatDescriptors = Utils.flatDescriptors(descriptors)
        .filter(d => d[DescriptorProps.DYNAMIC] === true)

    const rows = reportsChangesToMatrix(changedReports, affectedDescriptorIds, dynamicFlatDescriptors)

    return {
        rows,
        updatedReports: changedReports
            .filter(c => Object.keys(c.changes).length > 0)
            .map(c => c.updatedReport)
    }

}

function saveReports(updatedReports, schemaId, progressListener) {
    saveReport(updatedReports, 0, schemaId, progressListener)
}

function saveReport(updatedReports, idx, schemaId, progressListener) {
    if (updatedReports[idx] !== undefined) {
        ReportsRepo.update(Object.assign({ schemaId }, updatedReports[idx]), res => {
            progressListener.onSaved()
            saveReport(updatedReports, ++idx, schemaId, progressListener)
        })
    }
}

function getDescriptorsToUpdateStrategiesMap(descriptors) {
    return Utils.flatDescriptors(descriptors, true).reduce((acc, curr) => {
        acc[curr[DescriptorProps.ID]] = [];
        return acc
    }, {});
}

function BatchUpdateModal({ descriptors, schemaId, companyId, reports, closeModal, onSaved }) {
    const [descriptorsToUpdateStrategiesMap, setDescriptorsToUpdateStrategiesMap] =
        useState(() => getDescriptorsToUpdateStrategiesMap(descriptors))

    const handleUpdateStrategies = (descriptorId, strategy) => {
        setDescriptorsToUpdateStrategiesMap(prev => {
            const currentStrategies = prev[descriptorId];
            const isNewStrategyIncluded = currentStrategies.includes(strategy);

            const newDescriptorsToStrategiesMap = {
                ...prev,
                [descriptorId]: isNewStrategyIncluded
                    ? currentStrategies.filter(s => s !== strategy)
                    : [...currentStrategies, strategy]
            };

            return newDescriptorsToStrategiesMap
        })
    }
    return <BatchUpdateModalInternal {...getChanges(descriptors, reports, descriptorsToUpdateStrategiesMap, schemaId, companyId)}
        closeModal={closeModal} schemaId={schemaId} onSaved={onSaved}
        onUpdateStrategyChange={handleUpdateStrategies}
        descriptorsToUpdateStrategyMap={descriptorsToUpdateStrategiesMap} />
}

function BatchUpdateModalInternal({ rows, updatedReports, schemaId, closeModal, onSaved, onUpdateStrategyChange,
    descriptorsToUpdateStrategyMap }) {
    const [syncInProgress, setSyncInProgress] = useState(false);
    const [progressListener] = useState(() => {
        let updated = 0
        return {
            onSaved: () => {
                if (++updated === updatedReports.length) {
                    setSyncInProgress(false)
                    onSaved()
                }
            }
        }
    })

    const hasChanges = updatedReports.length > 0
    return syncInProgress ? <Loader /> : <Modal size='large' open={true}>
        <Modal.Header>Changes that are going to be applied.</Modal.Header>
        <Modal.Content className="overflowYScroll">
            {hasChanges ?
                <>
                    <BatchUpdateTable rows={rows} strategiesEnabled={true}
                        onUpdateStrategyChange={onUpdateStrategyChange}
                        descriptorsToUpdateStrategyMap={descriptorsToUpdateStrategyMap} />
                    <Container>
                        <p>
                            <b>Preserve CORE VALUES</b>: When this option is checked all non empty CORE VALUES will be preserved. <b>Correction</b> or <b>Calculation Disabled</b> will be applied in order to preserve the original value.
                        </p>
                        <p>
                            <b>Mark 3D Calced.</b>: When this option is checked, the field was previously empty and now it has a value, it will automatically be marked as <b>3D Calculated</b>.
                        </p>

                    </Container>
                </> : <>All reports already synchronised with the Model</>}
        </Modal.Content>
        <Modal.Actions>
            {hasChanges &&
                <Button size='mini' primary onClick={() => {
                    setSyncInProgress(true)
                    saveReports(updatedReports, schemaId, progressListener)
                }}>
                    Save Changes
                </Button>}
            <Button size='mini' onClick={closeModal}>
                Close
            </Button>

        </Modal.Actions>
    </Modal>
}

export default BatchUpdateModal